import styled from 'styled-components';
import IconSortDescending from './IconSortDescending';
var IconSortAscending = /*#__PURE__*/styled(IconSortDescending).withConfig({
  displayName: "IconSortAscending",
  componentId: "c11n-8-111-1__sc-j24y04-0"
})(["transform:scaleY(-1);"]);
export default IconSortAscending;